<template>
    <div>
        <div class="sub-lnb-menu">
            <ul class="sub-lnb-menu__list">
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==1}" @click="lnbFn(1)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step1')">病房提供的服务及注意事项</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==2}" @click="lnbFn(2)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step2')">准备物品</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==3}" @click="lnbFn(3)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step3')">查房信息</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==4}" @click="lnbFn(4)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step4')">供餐信息</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==5}" @click="lnbFn(5)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step5')">探病通知及注意事项</a>
                </li>
                <li class="sub-lnb-menu__item" :class="{active: this.lnbIndex==6}" @click="lnbFn(6)">
                    <div class="line"></div>
                    <a href="javascript:;" @click.prevent="scrollTo('step6')">其他事项</a>
                </li>
            </ul>
        </div>

        <!-- 대동맥 -->
        <div class="subSwiper info" v-if="$store.getters.getHost == 'H0006'">
            <swiper 
                :cssMode="true" 
                :navigation="{
                    nextEl: '.subSwiper-next',
                    prevEl: '.subSwiper-prev'
                }" 
                :pagination="{ clickable: true }" 
                :mousewheel="true" 
                :keyboard="true" 
                :modules="modules"
            >
                <swiper-slide>
                    <img src="/resource/img/info-img05.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/info-img06.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/info-img07.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/info-img08.jpg" alt="">
                </swiper-slide>
            </swiper>
            <div class="subSwiper-bth subSwiper-next"></div>
            <div class="subSwiper-bth subSwiper-prev"></div>
        </div>

        <!-- 뇌혈관 -->
        <div class="subSwiper info" v-else>
            <swiper 
                :cssMode="true" 
                :navigation="{
                    nextEl: '.subSwiper-next',
                    prevEl: '.subSwiper-prev'
                }" 
                :pagination="{ clickable: true }" 
                :mousewheel="true" 
                :keyboard="true" 
                :modules="modules"
            >
                <swiper-slide>
                    <img src="/resource/img/hospitalization01-brain.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/hospitalization02-brain.jpg" alt="">
                </swiper-slide>
                <swiper-slide>
                    <img src="/resource/img/hospitalization03-brain.jpg" alt="">
                </swiper-slide>
            </swiper>
            <div class="subSwiper-bth subSwiper-next"></div>
            <div class="subSwiper-bth subSwiper-prev"></div>
        </div>

        <div id="step1" class="step-item info">
            <h3 class="bullet01">病房提供的服务及注意事项</h3>
            <h4 class="bullet02 type2 num1 depth">紧急情况呼叫方法</h4>
            <p class="depth">
                紧急情况或需要护士帮助时，请按下床边或卫生间、浴室墙壁上的紧急铃，即可得到帮助。    
            </p>

            <h4 class="bullet02 type2 num2 depth">戴手环</h4>
            <p class="depth">
                为了准确识别患者，患者必须佩戴识别手环，该手环用于确认患者的姓名及登记号。如果您的手环弄脏或损坏，请通知护士室。我们将立即为您更换。
            </p>

            <h4 class="bullet02 type2 num3 depth">预防儿童患者失踪和被诱拐</h4>
            <p class="depth">
                为了预防儿童患者失踪及被诱拐，请监护人始终陪伴在儿童患者身边。
            </p>

            <h4 class="bullet02 type2 num4 depth">
                为了预防儿童患者失踪及被诱拐，请监护人始终陪伴在儿童患者身边。
            </h4>

            <h4 class="bullet02 type2 num5 depth">
                更换病房
            </h4>
            <p class="depth">
                在同一级别的病房内，出于患者安全考虑(如用药、采血、配餐及处置等环节)，禁止患者随意更换至自己希望的床位。
            </p>
        </div>
        <div id="step2" class="step-item info">
            <h3 class="bullet01">准备物品</h3>
            <div class="need-item">
                <div class="need-item__text">
                    <h4 class="bullet02 type2 num1 depth">个人准备物品</h4>
                    <p class="bullet03 depth font-main">患者身份证（必需）</p>
                    <p class="bullet05 depth"> 用于身份验证—可使用手机身份证和健康保险卡</p>
                    <p class="bullet05 depth"> 如果患者是未成年，则可用家庭关系证明书/户口本替代</p>
                    <p class="bullet05 depth font-sub"> 根据《国民健康保险法》实施“患者身份验证制度”（自2024年5月20日起生效）</p>
                    <p class="bullet03 depth">用药：请将正在服用的药物处方或写明药名的药袋提交给病房护士站</p>
                    <p class="bullet03 depth">物品：洗漱用品、毛巾、前后封闭的患者室内拖鞋（禁止拖鞋和克洛克斯）、卫生纸、水杯、陪护床上用品等个人物品</p>
                    <h4 class="bullet02 type2 num2 depth">其他事项</h4>
                    <p class="bullet03 depth">如果计划进行手术，请务必去除指甲护理</p>
                    <p class="bullet03 depth">物品：洗漱用品、毛巾、前后封闭的患者室内拖鞋（禁止拖鞋和克洛克斯）、卫生纸。为了预防感染、火灾和安全事故，禁止使用加湿器、电热水壶、电热毯、电风扇等电热器具和可燃热材料。陪护床上用品等个人物品</p>
                </div>
                <div class="need-item__img">
                    <img src="/resource/img/intensive--img01.png" alt="">
                </div>
            </div>
        </div>
        
        <div id="step3" class="step-item info">
            <h3 class="bullet01">查房信息</h3>
            <p class="depth">上午7:20点~09点左右查房，根据诊疗科情况可能会有变动。</p>
        </div>
        <div id="step4" class="step-item info">
            <h3 class="bullet01">供餐信息</h3>
            <p class="bullet04 num1 depth">
                早餐供应时间为上午7点~8点，午餐供应时间为中午12点~1点，晚餐供应时间为下午6点~7点左右，为了患者的治疗及预防感染，患者不得自带餐食或者在美食广场用餐。
            </p>
            <p class="bullet04 num2 depth">
                冰箱里的食物保管：熟食(发酵食品除外)保管时间过长可能会变质，因此最多只能保管24小时。
            </p>
            <p class="bullet04 num3 depth">
                如果患者愿意，可以选择非医保餐“特别餐”，这种情况下费用全部由患者自行承担。
            </p>
        </div>
        <div id="step5" class="step-item info">
            <h3 class="bullet01">探病通知及注意事项</h3>
            <p class="bullet04 num1 depth">
                为了患者的早日康复和稳定及预防感染，免疫力较弱的13岁以下儿童禁止进入感染病室和重症监护室探病。
            </p>
            <p class="bullet04 num2 depth">
                禁止患有感冒或传染病的监护人探病。如果您想保护自己的隐私或不想接受探病，请通知护士室。
            </p>
            <p class="bullet04 num3 depth">
                请配合医院填写管理访客的访客名册。
            </p>
            <p class="bullet04 num4 depth"><span class="font-main">探病时间</span></p>
            <p class="bullet05 depth">平日18:00~20:00</p>
            <p class="bullet05 depth">周末及公休日10:00~12:00，18:00~20:00</p>
            <p class="bullet05 depth">探病时间限制在2小时以内，20:00之后请勿探视患者。</p>
        </div>
        <div id="step6" class="step-item info">
            <h3 class="bullet01">其他事项</h3>
            <h4 class="bullet02 type2 num1 depth">便利设施</h4>
            <p class="depth">病区：有公用卫生间、污物处理清洗室、淋浴室、休息室、自动售货机、净水器、微波炉、多功能室等。</p>
            <p class="depth">有无人医疗缴费机、影像CD登记机、便利店、银行、咖啡厅、美食广场、面包店、医疗器械、无人快递箱等。</p>

            <h4 class="bullet02 type2 num2 depth">分类投放</h4>
            <p class="depth">请将使用过的酒精棉和纱布分类投放至医疗垃圾专用容器中。</p>

            <h4 class="bullet02 type2 num3 depth">禁烟</h4>
            <p class="depth">医院为了患者的健康和预防火灾，整个设施均为禁烟区，请配合禁烟。</p>

            <h4 class="bullet02 type2 num4 depth">预防火灾及发生火灾时的应对方法</h4>
            <p class="depth">病房内请勿使用便携式煤气灶、电风扇、电热器及携带易燃、可燃物质。一旦发生火灾，请立即通知护士并按照医院工作人员的指示通过疏散室和紧急楼梯疏散。</p>

            <h4 class="bullet02 type2 num5 depth">散步指南</h4>
            <p class="depth">
                原则上禁止到建筑物外散步。但是，在负责护士允许及监护人的陪同下，可以在建筑物4层花园、北门草坪广场散步。散步时请携带手机，并在下午6点前回到病房。
            </p>

            <h4 class="bullet02 type2 num6 depth">处理投诉和不满</h4>
            <p class="depth">
                若您在医院就诊期间遇到任何疑问、不便之处或希望表达称赞，您可以前往位于一楼的患者服务室、拨打服务热线、访问医院官方网站或利用客户意见箱进行反馈。
            </p>

            <h4 class="bullet02 type2 num7 depth">停车费</h4>
            <p class="depth">请参阅病区布告栏中张贴的停车费信息。</p>

            <h4 class="bullet02 type2 num8 depth">谨防丢失及失窃</h4>
            <p class="depth">
                <span class="font-main">
                    贵重物品和现金请勿在病房内保管，
                </span>
                假牙、助听器、眼镜、隐形眼镜等辅助器具在检查、治疗及手术时请取下并妥善保管。
                <span class="font-main">因本人不慎发生丢失时，本中心概不负责。</span>
            </p>
            <div class="depth">
                <div class="bullet-wrap">
                    <span class="font-main">随身物品管理</span>
                    <!-- <ul class="bullet-list">
                        <li class="bullet-item">본인관리</li>
                        <li class="bullet-item">보호자관리</li>
                    </ul> -->
                </div>
                <p>为检查或治疗取下时，请妥善保管，避免丢失。 </p>
                <p>因本人不慎发生丢失时，本中心概不负责。</p>

                <!-- <ul class="bullet-list type2">
                    <li class="bullet-item">틀니</li>
                    <li class="bullet-item">보청기</li>
                    <li class="bullet-item">안경</li>
                    <li class="bullet-item">시계</li>
                    <li class="bullet-item">귀걸이</li>
                    <li class="bullet-item">목걸이</li>
                    <li class="bullet-item">반지</li>
                    <li class="bullet-item">팔찌</li>
                    <li class="bullet-item">발찌</li>
                    <li class="bullet-item">열쇠</li>
                    <li class="bullet-item">지갑</li>
                    <li class="bullet-item">신발</li>
                    <li class="bullet-item">옷</li>
                    <li class="bullet-item">기타</li>
                    <li class="bullet-item">해당무</li>
                </ul> -->
            </div>


            <h4 class="bullet02 type2 num9 depth">宗教设施指南</h4>
            <p class="depth">
                本院是基督教医院，周日礼拜时间为周日上午10点，周三礼拜时间为周三下午5点，儿童/青少年礼拜时间为周四上午10点，在C馆3楼方舟教会进行。探访病房、信仰咨询、其他宗教咨询等可致电院牧咨询室(02-6986-5724)，院牧咨询室和祈祷室位于C馆3楼。
            </p>

            <h4 class="bullet02 type2 num10 depth">签发各种证明文件</h4>
            <p class="depth">
                请提前告知您的负责医生或护士需要的文件，例如诊断书、病历和影像副本。
            </p>

            <h4 class="bullet02 type2 num11 depth">我们在所有治疗过程中尊重并保护患者的权利和义务。</h4>
            <div class="table mt20">
                <div class="table__inner">
                    <table>
                        <colgroup>
                            <col style="width:40%;">
                            <col style="width:40%;">
                        </colgroup>
                        <thead>
                            <tr>
                                <th>患者的权利</th>
                                <th>患者的义务</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num1">接受诊疗的权利</p>
                                </td>
                                <td class="left" rowspan="2">
                                    <p class="bullet04 num1">对医务人员的信任和尊重义务</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num2">知情权和自主决定权</p>
                                </td>
                            </tr>


                            <tr>
                                <td class="left">
                                    <p class="bullet04 num3">保密权</p>
                                </td>
                                <td class="left" rowspan="3">
                                    <p class="bullet04 num2">不以不正当手段接受诊疗的义务</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num4">申请商谈调解的权利</p>
                                </td>
                            </tr>
                            <tr>
                                <td class="left">
                                    <p class="bullet04 num5">在安全的医疗环境中获得医疗服务的权利</p>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <h4 class="bullet02 type2 num12 depth mt30">拒绝诊疗信息</h4>
            <p class="depth">
                发生患者或监护人等对医务人员可能构成侮辱罪、名誉毁损罪、暴行罪、妨碍公务罪等情况，使医务人员不能进行正常行医时，可以在不违反《医疗法》和《应急医疗法》的范围内拒绝诊疗(拒绝诊疗权)。
            </p>
            <h4 class="bullet02 type2 num13 depth">
                患者或监护人(来访者)因暴力(恶语相向、威胁、骚乱、性暴力、性骚扰、损坏公物等)行为对工作人员造成损害的，可依据有关法令予以处罚。
            </h4>

        </div>

    </div>
</template>
<script>
    // Import Swiper Vue.js components
    import { Swiper, SwiperSlide } from 'swiper/vue';

    // Import Swiper styles
    import 'swiper/css';

    import 'swiper/css/navigation';
    import 'swiper/css/pagination';

    import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper/modules';

    export default {
        components: {
            Swiper,
            SwiperSlide,
        },
        setup() {
            return {
                modules: [Navigation, Pagination, Mousewheel, Keyboard],
            };
        },
        data() {
            return {
                lnbIndex: 1,
            };
        },
        mounted() {
            window.addEventListener('scroll', this.handleScroll);
        },
        methods: {
            scrollTo(id) {
                const element = document.getElementById(id);
                if (element) {
                    // 해당 요소의 위치와 크기 정보 가져오기
                    const elementTop = element.getBoundingClientRect().top + window.pageYOffset;

                    // 스크롤을 이동할 위치를 계산 (100px 추가)
                    const scrollToPosition = elementTop - 100;

                    // 계산된 위치로 부드럽게 스크롤
                    window.scrollTo({
                    top: scrollToPosition,
                    behavior: 'smooth'
                    });
                }
            },
            handleScroll() {
                const sections = document.querySelectorAll('.step-item');
                sections.forEach((section, index) => {
                    const rect = section.getBoundingClientRect();
                    // Check if the top of the section is within the viewport
                    if (rect.top <= 101 && rect.top <= window.innerHeight) {
                        this.lnbIndex = index + 1; // Update lnbIndex based on the section's position
                    }
                });
            },
            lnbFn(index) {
                this.lnbIndex = index; // Change the active index when clicking the menu
            },
        },
    };
</script>